/**
 * MontaTech v2 - Native C# Apply Positioning
 *
 * Aplica resultado do PlotCalc nos shapes do CorelDRAW via C# nativo.
 * Action: "nesting:apply-native"
 *
 * Requer coleta C# prévia (nesting:collect-native) para o mapa curveIndex→StaticID.
 */

import { corelCommunication } from '../../../../lib/corel/communication';
import { sendToTerminal } from '../../../../lib/terminalLogger';

interface ApplyResult {
  success: boolean;
  figuresApplied?: number;
  figuresFailed?: number;
  durationMs?: number;
  error?: string;
}

/**
 * Aplica posições do PlotCalc nos shapes do CorelDRAW via C# nativo.
 * @param plotcalcResponse - Resposta completa do PlotCalc (figures, materials, etc.)
 * @param profile - Perfil ativo usado no calculo (necessario para reproduzir blocos/material no apply nativo)
 */
export function applyNestingNative(plotcalcResponse: any, profile?: any): Promise<ApplyResult> {
  return new Promise((resolve) => {
    const startTime = Date.now();
    const timeoutMs = 30000;

    sendToTerminal('⚡ [NATIVE-APPLY] Enviando action nesting:apply-native ao C#');

    const requestId = corelCommunication.sendActionGuarded(
      'nesting:apply-native',
      { plotcalcResponse, profile },
      (response: any) => {
        const elapsed = Date.now() - startTime;

        sendToTerminal('📥 [NATIVE-APPLY] Resposta recebida do C#', {
          status: response?.status,
          elapsedMs: elapsed
        });

        if (response?.status === 'success' && response?.result) {
          const result = response.result;


          resolve({
            success: true,
            figuresApplied: result.figuresApplied,
            figuresFailed: result.figuresFailed,
            durationMs: result.durationMs
          });
        } else {
          const errorMsg = response?.message || 'Erro ao aplicar posições';
          sendToTerminal('❌ [NATIVE-APPLY] Falha', { error: errorMsg, code: response?.code });
          resolve({ success: false, error: errorMsg });
        }
      },
      timeoutMs
    );

    sendToTerminal('🧾 [NATIVE-APPLY] Resultado do envio', {
      requestId: requestId || null,
      timeoutMs,
      webViewAvailable: corelCommunication.isWebViewAvailable(),
      pendingRequests: corelCommunication.getPendingRequestsCount()
    });

    if (!requestId) {
      sendToTerminal('❌ [NATIVE-APPLY] Falha ao enviar action (WebView indisponível)');
      resolve({ success: false, error: 'WebView2 não disponível' });
    }
  });
}
